import CobranzaForm from './CobranzaForm'
export {CobranzaForm}
export default CobranzaForm
